import React from "react";
import indexRoutes from "./routes";
import { Redirect, Route, Switch } from "react-router";
import { BrowserRouter as Router } from "react-router-dom";
import { PrivateRoute } from "./routes/PrivateRoutes";
import BlankLayout from "./layouts/BlankLayout";

const RouterApp = () => {
  return (
    <Router>
      <Switch>
        <Route exact path="/authentication/login" component={BlankLayout} />
        <Route exact path="/authentication/esqueci-senha/validar-token" component={BlankLayout} />
        <Route exact path="/authentication/pre-cadastro/:token" component={BlankLayout} />
        <Route exact path="/authentication/esqueci-senha" component={BlankLayout} />
        {indexRoutes.map((prop, key) => {
          return (
            <PrivateRoute
              path={prop.path}
              key={key}
              component={prop.component}
            />
          );
        })}
        <Redirect from="*" to="/authentication/Login"></Redirect>
      </Switch>
    </Router>
  );
};

export default RouterApp;
